export default __webpack_public_path__ + "static/media/misionesIcono.ba8e785e.jpg";